/**
 * 马甲库管理
 */

import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.vestManageAccountList,
    component: () => import('../../pages/vestManage/accountList'),
    meta: { title: '马甲账号管理' }
  },
  {
    path: routeNames.vestManageTitleList,
    component: () => import('../../pages/vestManage/titleList'),
    meta: { title: '荣誉称号管理' }
  }
] as TRoutes[]
